var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m137.173 240.038 145.717-53.686 62.758 62.758-82.758-82.758-145.717 53.686-53.145 219.449 32.783-32.782z",
    fill: "#d4e1f4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m230.462 85.338h84.371v28.284h-84.371z",
    fill: "#d4e1f4",
    transform: "matrix(.707 -.707 .707 .707 9.514 221.928)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m297.9 405.737a6 6 0 0 0 4.218-3.758l56.119-152.323a6 6 0 1 0 -11.259-4.148l-55.015 149.319-219.451 53.146 108.411-108.411a45.7 45.7 0 1 0 -8.481-8.489l-108.414 108.414 53.145-219.449 149.319-55.013a6 6 0 1 0 -4.148-11.26l-152.323 56.119a6 6 0 0 0 -3.757 4.218l-58.528 241.677-.813.813a6 6 0 1 0 8.484 8.486l.812-.812zm-113.018-126.254a33.683 33.683 0 0 1 47.634 0 33.682 33.682 0 1 1 -47.635 0z",
    fill: "#2f55d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m388.448 291.91a6 6 0 0 0 8.485 0l68.144-68.145a6 6 0 0 0 0-8.485l-168.357-168.358a6 6 0 0 0 -8.485 0l-68.144 68.145a6 6 0 0 0 0 8.486zm-95.97-232.26 159.872 159.872-59.66 59.66-159.872-159.872z",
    fill: "#2eca8b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.376f53c9b476e13adbdaf98666ef11b7.svg";
export { ForwardRef as ReactComponent };